<template>
  <va-edit-layout :actions="['list', 'show', 'delete']">
    <fields-form :id="id" :title="title" :item="item"></fields-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ['id', 'title', 'item'],
}
</script>
